// extracted by mini-css-extract-plugin
module.exports = {"title":"KeyTermsListBlock_title__1Gvc4","container":"KeyTermsListBlock_container__1roOJ","list":"KeyTermsListBlock_list__Y2gZx","headerRow":"KeyTermsListBlock_headerRow__yvP6J"};